import { useRef } from 'react';

type ColorSwatchProps = {
  color: string;
  onChange: (color: string) => void;
};

const ColorSwatch = ({ color, onChange }: ColorSwatchProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div
      className="relative px-4 h-8 cursor-pointer"
      style={{ backgroundColor: color }}
      onClick={() => inputRef.current?.click()}
    >
      <input
        ref={inputRef}
        type="color"
        className="absolute bottom-0 right-0 w-0 h-0 opacity-0 pointer-events-none"
        style={{ colorScheme: 'dark' }}
        value={color}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

export default ColorSwatch;
